import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {DocumentService} from '../../services/document.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {DocumentTable} from '../../models/document-table';
import {MessageService, SelectItem} from 'primeng/api';
import {DocumentFilterCriteria} from '../../models/filter/document-filter-criteria';
import {Column} from '../../share/models/column';
import {BaseClientComponent} from '../base-client.component';
import {HttpClient} from '@angular/common/http';
import * as _ from 'lodash';
import {Document} from '../../models/document';
import {saveAs} from 'file-saver';
import {OverlayPanel} from 'primeng/overlaypanel';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class DocumentsComponent extends BaseClientComponent implements OnInit {

  @ViewChild('dataTable') dataTable: any;
  cols: Column[];
  documentsList: DocumentTable[];
  filteredDocumentsList: DocumentTable[];
  size: number;
  tags: SelectItem[] = [];
  availableToOptions: SelectItem[] = [];
  documentFilterCriteria: DocumentFilterCriteria;
  error = false;
  loadError = false;
  notFoundError = false;
  deleteDocumentAlert = false;
  undeleteDocumentAlert = false;
  documentFileNotFound = false;
  documentLinkError = false;
  showDeletedDocuments = false;
  userChoicesFiltersDefaultDocuments = {
    title: '',
    isNew: false,
    availableTo: [],
    tags: []
  };
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultDocuments);
  errorExport: boolean;
  watchedDocumentsList = [];
  watchersByDocument = [];
  isSubscribed = false;

  constructor(public utilsService: UtilsService,
              private documentService: DocumentService,
              public authenticationService: AuthenticationService,
              private messageService: MessageService,
              protected http: HttpClient) {
    super();
  }

  ngOnInit() {
    this.tags = [
      {label: 'API', value: 'API'},
      {label: 'Encrypted', value: 'Encrypted'},
      {label: 'Finance or accounting', value: 'Finance or accounting'},
      {label: 'Getting Started', value: 'Getting Started'},
      {label: 'Network', value: 'Network'},
      {label: 'Non Encrypted', value: 'Non Encrypted'},
      {label: 'Tech Specs', value: 'Tech Specs'},
      {label: 'Quincy Data', value: 'Quincy Data'},
    ];
    this.availableToOptions = [
      {label: 'McKay Brothers', value: 'mckay'},
      {label: 'Quincy Data', value: 'quincy'},
      {label: 'Vendor', value: 'vendor'},
      {label: 'Selected Clients', value: 'whitelist'},
    ];
    this.userChoicesActiveFilters = this.utilsService.loadUserPref(
      'documentFilter',
      this.userChoicesFiltersDefaultDocuments
    );
    this.documentLinkError = this.documentService.fileNotFound;
    this.documentService.fileNotFound = false;
    this.isSubscribed = this.getUserCurrent().subscribeToDocumentReport;
    this.documentFilterCriteria = new DocumentFilterCriteria(
      this.userChoicesActiveFilters.title,
      this.userChoicesActiveFilters.availableTo,
      this.userChoicesActiveFilters.isNew,
      this.userChoicesActiveFilters.tags,
      this.userChoicesActiveFilters.watchedFiles
    );
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getDocumentsList();
    });
    this.subscriptions.push(response$);
  }

  showOrHideDocument() {
    this.showDeletedDocuments = !this.showDeletedDocuments;
    this.filter();
    if (!this.showDeletedDocuments) {
      this.size = this.documentsList.filter(document => !document.deleted).length;
    } else if (this.filteredDocumentsList) {
      this.size = this.filteredDocumentsList.length;
    } else {
      this.size = this.documentsList.length;
    }
  }

  filter() {
    this.documentFilterCriteria.title = this.documentFilterCriteria.title.trim();
    this.utilsService.saveUserData('documentFilter',
      {
        'title': this.documentFilterCriteria.title,
        'availableTo': this.documentFilterCriteria.availableTo,
        'tags': this.documentFilterCriteria.tags,
        'isNew': this.documentFilterCriteria.isNew,
        'watchedFiles': this.documentFilterCriteria.watchedFiles
      });
    this.filteredDocumentsList = [];
    if (this.getUserCurrent().permissions.isMckayUser) {
      this.documentsList.forEach(document => {
        if ((this.showDeletedDocuments || !document.deleted) && this.filterTitle(document) && this.filterTags(document)
          && this.filterAvailableTo(document) && (!this.documentFilterCriteria.isNew
            || (this.documentFilterCriteria.isNew && this.isNewDocument(document.availableSince)))) {
          this.filteredDocumentsList.push(document);
        }
      });
    } else {
      this.documentsList.forEach(document => {
        if (this.filterTitle(document) && this.filterTags(document) &&
          (!this.documentFilterCriteria.isNew || (this.documentFilterCriteria.isNew && this.isNewDocument(document.availableSince))) &&
          (!this.documentFilterCriteria.watchedFiles || (this.documentFilterCriteria.watchedFiles && this.watchedDocumentsList.includes(document.id)))) {
          this.filteredDocumentsList.push(document);
        }
      });
    }
    this.size = this.filteredDocumentsList ? this.filteredDocumentsList.length : 0;
    this.dataTable.reset();
  }

  filterTitle(document: DocumentTable) {
    if (!this.documentFilterCriteria.title) {
      return true;
    }
    const searchedWords = this.documentFilterCriteria.title.trim().toLowerCase().split(' ');
    return searchedWords.every(word => {
      return (
        !document.title || document.title === '' ||
        document.title.toLowerCase().includes(word)
      );
    });
  }

  filterTags(document: DocumentTable) {
    if (!this.documentFilterCriteria.tags || this.documentFilterCriteria.tags.length === 0) {
      return true;
    } else {
      const documentTags = document.tags.replace(/,\s/g, ';').split(';');
      const selectedTags = this.documentFilterCriteria.tags;
      return selectedTags.every(tag => documentTags.includes(tag));
    }
  }


  filterAvailableTo(document: DocumentTable) {
    let length = this.documentFilterCriteria.availableTo.length;
    if (length === 0) {
      return true;
    } else {
      while (length--) {
        if (this.documentFilterCriteria.availableTo[length].indexOf('mckay') !== -1
          && (document.availableTo.includes('McKay clients')
            || document.availableTo.indexOf('All clients') !== -1
            || document.availableTo.indexOf('Clients & vendors') !== -1)) {
          return true;
        } else if (this.documentFilterCriteria.availableTo[length].indexOf('quincy') !== -1
          && (document.availableTo.includes('Quincy clients')
            || document.availableTo.indexOf('All clients') !== -1
            || document.availableTo.indexOf('Clients & vendors') !== -1)) {
          return true;
        } else if (this.documentFilterCriteria.availableTo[length].indexOf('vendor') !== -1
          && (document.availableTo.includes('Vendor')
            || document.availableTo.includes('vendors'))) {
          return true;
        } else if (this.documentFilterCriteria.availableTo[length].indexOf('whitelist') !== -1
          && document.availableTo.includes('Selected clients')) {
          return true;
        }
      }
      return false;
    }
  }

  isNewDocument(availableSince: Date) {
    const limit = new Date();
    const day = limit.getDate();
    limit.setDate(1);
    limit.setMonth(limit.getMonth() - 2);
    limit.setDate(Math.min(day, new Date(limit.getFullYear(), limit.getMonth() + 1, 0).getDate()));
    return new Date(availableSince) > limit;
  }

  reset() {
    this.documentFilterCriteria = new DocumentFilterCriteria('', [], false, [], false);
    this.filter();
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  editDocument(document: DocumentTable): void {
    location.assign('/#/document/' + document.uniqid + '/edit');
  }

  showDocument(document: DocumentTable): void {
    location.assign('/#/document/' + document.uniqid + '/show');
  }

  redirectToDownloadLog(document: DocumentTable): void {
    location.assign('/#/' + this.getUserCurrent().company.uniqid + '/download-log?title=' + document.filename);
  }

  deleteDocument(document: DocumentTable): void {
    this.deleteDocumentAlert = false;
    this.undeleteDocumentAlert = false;
    if (confirm(`Are you sure you want to delete "${document.fileTitle}" ?`)) {
      const documentId = document.id;
      this.documentService.deleteDocument(document.uniqid).subscribe({
          next: () => {
            document.deleted = true;
            this.documentsList.find(doc => doc.id === documentId).title
              = this.documentsList.find(doc => doc.id === documentId).title
              + ' ' + '<span class="font-weight-bold text-danger">' + 'Deleted' + '</span>';
            this.deleteDocumentAlert = true;
          },
          error: () => {
            document.deleted = false;
          }
        }
      );
    }
  }

  undeleteDocument(document: DocumentTable): void {
    this.deleteDocumentAlert = false;
    this.undeleteDocumentAlert = false;
    if (confirm(`Are you sure you want to undelete "${document.fileTitle}" ?`)) {
      const documentId = document.id;
      this.documentService.undeleteDocument(document.uniqid).subscribe({
          next: () => {
            document.deleted = false;
            this.documentsList.find(doc => doc.id === documentId).title
              = this.documentsList.find(doc => doc.id === documentId).title.substring(0,
              this.documentsList.find(doc => doc.id === documentId).title.indexOf
              ('<span class="font-weight-bold text-danger">' + 'Deleted' + '</span>'));
            this.undeleteDocumentAlert = true;
          },
          error: () => {
            document.deleted = true;
          }
        }
      );
    }
  }

  canEditOrDeleteDocument() {
    return this.authenticationService.userHasOneOfThoseRoles(['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DEVELOPER']);
  }

  private initTablesBasedOnLoggedInUser() {
    this.cols = [];
    if (this.getUserCurrent().permissions.isMckayUser) {
      this.documentService.getNumberOfWatchersByDocument().subscribe(res => {
        this.watchersByDocument = res;
        this.documentsList.forEach(document => {
          document.nbOfWatchers = this.watchersByDocument[document.id] ? this.watchersByDocument[document.id].length : 0;
        });
      });
      this.cols = [
        {field: 'title', header: 'Title', type: 'string', sortable: false, width: '25%'},
        {field: 'filename', header: 'Filename', type: 'string', sortable: false, width: '20%'},
        {field: 'size', header: 'Size', type: 'string', sortable: false, width: ''},
        {field: 'availableTo', header: 'Available to', type: 'string', sortable: false, width: ''},
        {field: 'availableSince', header: 'Available Since', sortable: false, type: 'date', width: ''},
        {field: 'uploadedBy', header: 'Uploaded by', type: 'string', sortable: false, width: '8%'},
        {field: 'nbOfWatchers', header: 'Nb of watchers', type: 'string', sortable: false, width: ''},
        {field: 'monitorDownloads', header: 'Monitor downloads', type: 'checked', sortable: false, width: ''},
        {field: 'actions', header: 'Actions', type: 'action', sortable: false, width: '11%'},
      ];
    } else {
      this.documentService.getUsersWatchedDocumentList().subscribe(res => {
        this.watchedDocumentsList = res;
      });
      this.cols = [
        {field: 'title', header: 'Title', type: 'string', sortable: true, sortField: 'fileTitle', width: '45%'},
        {field: 'filename', header: 'Filename', type: 'string', sortable: true, width: '25%'},
        {field: 'size', header: 'Size', type: 'string', sortable: false, width: ''},
        {field: 'availableSince', header: 'Available Since', sortable: true, type: 'date', width: ''},
        {field: 'uploadedBy', header: 'Uploaded by', type: 'string', sortable: false, width: ''},
        {field: 'actions', header: 'Actions', type: 'action', sortable: false, width: '11%'},
      ];
    }
  }

  private getDocumentsList() {
    this.utilsService.lockUi();
    this.documentService.getDocuments().subscribe({
        next: documents => {
          this.size = this.showDeletedDocuments ? (documents ? documents.length : 0) : (documents ? documents.filter(doc => !doc.deleted).length : 0);
          this.getDocumentsTable(documents);
          this.initTablesBasedOnLoggedInUser();
          this.utilsService.unlockUi();
        },
        error: () => {
          this.loadError = true;
          this.utilsService.unlockUi();
        }
      }
    );
  }

  private getDocumentsTable(documents: Document[]) {
    this.documentsList = [];
    this.filteredDocumentsList = [];
    documents.forEach(document => {
      this.documentsList.push(new DocumentTable(document, this.isNewDocument(document.availableSince)));
    });
    this.filter();
  }

  downloadDocument(document: Document) {
    this.utilsService.lockUi();
    this.documentService.downloadDocumentFile(document.uniqid).subscribe({
        next: res => {
          this.documentFileNotFound = false;
          this.downLoadFile(res, document.filename);
          this.watchedDocumentsList.push(document.id);
          this.utilsService.unlockUi();
        },
        error: () => {
          this.notFoundError = true;
          this.utilsService.unlockUi();
        }
      }
    );
  }

  getDocumentByUniqid(documentUniqid) {
    this.documentService.getDocumentByUniqid(documentUniqid).subscribe({
        next: document => {
          if (document[0]) {
            this.downloadDocument(document[0]);
          } else {
            this.documentFileNotFound = true;
          }
        },
        error: () => {
          this.documentFileNotFound = true;
        }
      }
    );
  }

  downLoadFile(data: any, fileName: string) {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    // opening the download file in a new tab
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  exportAsExcel() {
    this.errorExport = false;
    this.documentService.exportAsExcel().subscribe({
        next: res => {
          const fileMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = this.utilsService.b64toBlob(res['file_content'], fileMimeType, null);
          saveAs(blob, res['file_name']);
        }, error: () => {
          this.errorExport = true;
        }
      }
    );
  }

  copyDocumentUrl(documentUniqId: any) {
    const url = `${window.location.origin}/#/document/${documentUniqId}/download`;
    // creating an url of the document based on document
    navigator.clipboard.writeText(url)
      .then(() => {
        this.showSuccess();
      })
      .catch((error) => {
        console.error('error while trying to copy URL to clipboard ', error);
      });
  }

  showSuccess() {
    this.messageService.add({key: 'tl', severity: 'success', summary: 'Success', detail: 'Link copied to clipboard'});
  }

  watchDocument(document: any) {
    this.documentService.watchDocument(document).subscribe(() => {
      this.watchedDocumentsList.push(document.id);
    });
  }

  unwatchDocument(document: any) {
    this.documentService.unwatchDocument(document).subscribe(() => {
      this.watchedDocumentsList = this.watchedDocumentsList.filter(id => id !== document.id);
      this.filter();
    });
  }

  displayWatchersPopUp(event: MouseEvent, overlayPanel: OverlayPanel, document: Document) {
    if (document.nbOfWatchers > 0) {
      overlayPanel.toggle(event);
    }
  }

  protected subscribeToWeeklyReport() {
    this.documentService.subscribeToReport()
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Subscribed',
            detail: 'You are subscribed to the weekly report.'
          });
          this.authenticationService.userCurrent.subscribeToDocumentReport = true;
          this.isSubscribed = true;
        },
        error: err => {
          this.authenticationService.userCurrent.subscribeToDocumentReport = false;
          this.isSubscribed = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Subscription failed',
            detail: 'Could not subscribe. Please try again.'
          });
          console.error('Subscribe error', err);
        }
      });
  }


  toggleSubscription() {
    if (this.isSubscribed) {
      this.unsubscribeFromWeeklyReport();
    } else {
      this.subscribeToWeeklyReport();
    }
  }

  private unsubscribeFromWeeklyReport() {
    this.documentService.unSubscribeFromReport()
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'info',
            summary: 'Unsubscribed',
            detail: 'You have been unsubscribed from the weekly report.'
          });
            this.isSubscribed = false;
          this.authenticationService.userCurrent.subscribeToDocumentReport = false;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Unsubscription failed',
            detail: 'Could not unsubscribe. Please try again.'
          });
        }
      });
  }
}
